<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <loadingcomp
      v-bind:mesaj="loadingmesaj"
      v-model="loadingvmodel"
    ></loadingcomp>
    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 md12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>Acente Komisyon</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-text-field
              flat=""
              @keyup.enter="getAcenteKomisyonListPageOne()"
              solo-inverted=""
              hide-details
              v-model="komisyonListParams.Filtreler.SearchText"
              :label="$t('Search')"
              @click:append="getAcenteKomisyonListPageOne()"
              append-icon="live_help"
            ></v-text-field>
            <!-- <v-btn class="white--text" flat @click="paximumAdd()">
              Paximum Otel Ekle
              <v-icon right>add_box</v-icon>
            </v-btn> -->

            <v-btn class="white--text" flat @click="addDialogOpen()">
              {{ $t('Add-v2', { value: $t('Commission')}) }} 
              <v-icon right>add_box</v-icon>
            </v-btn>
          </v-toolbar>
        </v-flex>

        <v-flex xs12 sm12 md12 pa-3>
          <v-card class="pa-2">
            <v-layout row wrap align-center>
              <v-flex xs12 sm12 md3>
                <genelarama
                  apiname="SaticiAra"
                  :tip="4"
                  :label="$t('Agency')"
                  v-model="komisyonListParams.Filtreler.AcenteKodu"
                ></genelarama>
              </v-flex>

              <v-flex xs12 sm12 md1>
                <v-btn color="info" fab small @click="getAcenteKomisyonList()"
                  ><v-icon>search</v-icon></v-btn
                >
              </v-flex>

              <v-flex
                xs12
                sm12
                md5
                class="headline font-weight-regular pl-3 grey--text"
              >
                {{ totalCountText }}
              </v-flex>
              <v-flex xs12 sm12 md2>
                <v-select
                  :label="$t('Sort-By')"
                  hide-details
                  :items="siralamaItems"
                  item-text="Text"
                  item-value="Value"
                  v-model="komisyonListParams.Paging.SiralamaTip"
                  @change="getAcenteKomisyonListPageOne()"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm12 md1>
                <v-select
                  :label="$t('Show')"
                  hide-details
                  :items="veriItem"
                  item-text="Text"
                  item-value="Value"
                  v-model="komisyonListParams.Paging.VeriAdet"
                  @change="getAcenteKomisyonListPageOne()"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <v-flex
          v-for="(item, index) in acenteKomisyonList"
          :key="index"
          pa-3
          xs12
          sm12
          md12
        >
          <v-hover>
            <v-card
              width="100%"
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 12 : 2}`"
              class="elevation-1 pa-3"
            >
              <v-layout row wrap align-center justify-end>
                <v-flex xs12 sm6 md2>
                  <v-layout row wrap>
                    <v-flex
                      xs12
                      sm6
                      md12
                      class="font-weight-medium grey--text subheader"
                    >
                      <v-layout row wrap>
                        <v-flex xs6 sm12 md12>
                          <v-icon style="color: #67768f" left>home_work</v-icon>
                          {{ item.AcenteAd }}</v-flex
                        >
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm6 md3>
                  <v-layout row wrap>
                    <v-flex
                      xs12
                      sm6
                      md12
                      class="font-weight-medium grey--text subheader"
                    >
                      <v-icon style="color: #67768f" left>payment</v-icon>
                      {{ item.SaticiKod }} - {{ item.SaticiAd }}
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm6 md2>
                  <v-layout row wrap>
                    <v-flex
                      xs12
                      sm6
                      md12
                      class="font-weight-medium grey--text subheader"
                    >
                      <v-layout row wrap>
                        <v-flex xs6 sm12 md6 style="color: #67768f"
                          >{{ $t('Start') }} :</v-flex
                        >
                        <v-flex xs6 sm12 md6>{{
                          item.BasTarihi | dateformat
                        }}</v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md12
                      class="font-weight-medium grey--text subheader"
                    >
                      <v-layout row wrap>
                        <v-flex xs6 sm12 md6 style="color: #67768f"
                          > {{ $t('Finish') }} :</v-flex
                        >
                        <v-flex xs6 sm12 md6>{{
                          item.BitTarihi | dateformat
                        }}</v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm6 md2>
                  <v-layout row wrap>
                    <v-flex
                      xs12
                      sm6
                      md12
                      class="font-weight-medium grey--text subheader"
                    >
                      <v-layout row wrap>
                        <v-flex xs6 sm12 md8 style="color: #67768f"
                          > {{ $t('Commission-Percentage') }} :</v-flex
                        >
                        <v-flex xs6 sm12 md4>{{ item.KomYuzde }}</v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md12
                      class="font-weight-medium grey--text subheader"
                    >
                      <v-layout row wrap>
                        <v-flex xs6 sm12 md8 style="color: #67768f"
                          >{{ $t('Commission-Amount-v2') }}:</v-flex
                        >
                        <v-flex xs6 sm12 md4>{{ item.KomTutar }}</v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm12 md2>
                  <v-layout row wrap>
                    <v-flex
                      xs12
                      sm6
                      md12
                      class="font-weight-medium grey--text subheader"
                    >
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md6 style="color: #67768f"
                          >{{ $t('Money') }} :</v-flex
                        >
                        <v-flex xs12 sm12 md6>{{ item.Para }}</v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex
                      xs12
                      sm6
                      md12
                      class="font-weight-medium grey--text subheader"
                    >
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md6 style="color: #67768f"
                          >{{ $t('Exchange-Rate-v2') }}:</v-flex
                        >
                        <v-flex xs12 sm12 md6>{{ item.Kur }}</v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm12 md1>
                  <v-layout row wrap>
                    <v-flex xs6 sm2 md6>
                      <v-btn
                        color="info"
                        @click="LoadKomisyon(item.Ref)"
                        outline
                        fab
                        small
                      >
                        <v-icon>search</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs6 sm2 md6>
                      <v-btn
                        color="error"
                        outline
                        fab
                        small
                        @click="deleteAcenteKomisyon(item.Ref)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-hover>
        </v-flex>

        <!-- sayfalama -->
        <v-flex xs12 sm12 md12>
          <v-layout justify-center>
            <template v-if="vmodelpagination">
              <div class="text-xs-center">
                <v-container>
                  <v-layout justify-center>
                    <v-flex xs8>
                      <v-pagination
                        :disabled="paginationDisabled"
                        color="info"
                        v-model="komisyonListParams.Paging.SayfaNo"
                        :length="totalResultCount"
                      ></v-pagination>
                    </v-flex>
                  </v-layout>
                </v-container>
              </div>
            </template>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>

    <v-dialog v-model="komisyonDialog" max-width="600px">
      <v-card flat color="grey lighten-4">
        <v-card-title>  {{ $t('Add-v2', { value: $t('Commission')}) }}  </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm6 md6>
              <v-flex xs12 sm6 md12>
                <genelarama
                  apiname="SaticiAra"
                  :tip="4"
                  :label="$t('Agency')"
                  v-model="komisyonParams.Acente"
                ></genelarama>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <tarihim
                  :etiket="$t('Starting-Date')"
                  :detaygizle="true"
                  v-model="komisyonParams.TarihBilgisi.BasTarihi"
                  v-bind:defaultvalue="'no'"
                >
                </tarihim>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <tarihim
                  :etiket="$t('Finishing-Date')"
                  :detaygizle="false"
                  v-model="komisyonParams.TarihBilgisi.BitTarihi"
                  v-bind:defaultvalue="'no'"
                >
                </tarihim>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-select
                  :label="$t('Commission-Calculation-Method')"
                  v-model="komisyonParams.TarihBilgisi.Tip"
                  :items="komisyonHesaplaTip"
                  item-text="text"
                  item-value="value"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-checkbox :label="$t('All-v2')" v-model="komisyonParams.Tumu">
                </v-checkbox>
              </v-flex>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-flex xs12 sm6 md12>
                <v-select
                  clearable
                  :items="itemssaticitip"
                  item-text="Aciklama"
                  item-value="Kod"
                  :label="$t('Seller-Type')"
                  v-model="komisyonParams.SaticiTip"
                  hide-details
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <genelarama
                  apiname="SaticiAra"
                  :tip="komisyonParams.SaticiTip"
                  v-model="komisyonParams.Satici"
                ></genelarama>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-select
                  :label="$t('Exchange-Rate-v2')"
                  item-text="Title"
                  item-value="DovizKod"
                  @input="getKur(1)"
                  :items="doviztipi"
                  v-model="komisyonParams.Para"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-text-field :label="$t('Exchange-Rate-v2')" v-model="komisyonParams.Kur">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-text-field
                  v-model="komisyonParams.KomYuzde"
                  :label="$t('Commission-Percentage')"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-text-field
                  v-model="komisyonParams.KomTutar"
                  :label="$t('Commission-Amount-v2')"
                >
                </v-text-field>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="komisyonDialog = false"
            >{{ $t("cancel_button") }}</v-btn
          >
          <v-btn color="blue darken-1" flat @click.native="addKomisyon()"
            > {{ $t('save_button') }}  </v-btn
          >
        </v-card-actions></v-card
      >
    </v-dialog>

    <v-dialog v-model="komisyonUpdateDialog" max-width="600px">
      <v-card flat color="grey lighten-4">
        <v-card-title>Komisyon Güncelle</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm6 md6>
              <v-flex xs12 sm6 md12>
                <genelarama
                  apiname="SaticiAra"
                  :tip="4"
                  label="Acente"
                  v-model="komisyonUpdateParams.Acente"
                ></genelarama>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <tarihim
                  :etiket="$t('Starting-Date')"
                  :detaygizle="true"
                  v-model="komisyonUpdateParams.TarihBilgisi.BasTarihi"
                  v-bind:defaultvalue="'no'"
                >
                </tarihim>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <tarihim
                  :etiket="$t('Finishing-Date')"
                  :detaygizle="false"
                  v-model="komisyonUpdateParams.TarihBilgisi.BitTarihi"
                  v-bind:defaultvalue="'no'"
                >
                </tarihim>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-select
                  :label="$t('Commission-Calculation-Method')"
                  v-model="komisyonUpdateParams.TarihBilgisi.Tip"
                  :items="komisyonHesaplaTip"
                  item-text="text"
                  item-value="value"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-checkbox :label="$t('All-v2')" v-model="komisyonUpdateParams.Tumu">
                </v-checkbox>
              </v-flex>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-flex xs12 sm6 md12>
                <v-select
                  clearable
                  :items="itemssaticitip"
                  item-text="Aciklama"
                  item-value="Kod"
                  :label="$t('Seller-Type')"
                  v-model="komisyonUpdateParams.SaticiTip"
                  hide-details=""
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <genelarama
                  apiname="SaticiAra"
                  :tip="komisyonUpdateParams.SaticiTip"
                  v-model="komisyonUpdateParams.Satici"
                ></genelarama>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-select
                  :label="$t('Exchange-Rate-v2')"
                  item-text="Title"
                  item-value="DovizKod"
                  @input="getKur(2)"
                  :items="doviztipi"
                  v-model="komisyonUpdateParams.Para"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-text-field :label="$t('Exchange-Rate-v2')" v-model="komisyonUpdateParams.Kur">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-text-field
                  v-model="komisyonUpdateParams.KomYuzde"
                  :label="$t('Commission-Percentage')"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-text-field
                  v-model="komisyonUpdateParams.KomTutar"
                  :label="$t('Commission-Amount-v2')"
                >
                </v-text-field>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="komisyonUpdateDialog = false"
            >{{ $t("cancel_button") }}</v-btn
          >
          <v-btn color="blue darken-1" flat @click.native="updateKomisyon()"
            >{{ $t('save_button') }} </v-btn
          >
        </v-card-actions></v-card
      >
    </v-dialog>

    <serviceacentekomisyon
      ref="serviceAcente"
      :SaticiTip="1"
      v-model="paximumOtel"
    ></serviceacentekomisyon>
  </div>
</template>

<script>
import tool from "../../coper/tools";
import helpers from "@/components/app/customcomp/helpers.js";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import rez from "../rezervasyon";
import auth from "@/api/auth";
import serviceacentekomisyon from "@/components/app/coper/comp/serviceacentekomisyon.vue";

export default {
  data() {
    return {
      komisyonHesaplaTip: [
        {
          text: this.$t('Calculate-Per-Recording-Date'),
          value: 0,
        },
        {
          text: this.$t('Calculate-Per-Visitation-Date'),
          value: 1,
        },
      ],
      itemssaticitip: rez.SaticiTip,
      komisyonDialog: false,
      komisyonUpdateDialog: false,
      komisyonUpdateParams: {
        Ref: 0,
        Acente: {
          YurtIci_YurtDisi: 0,
          CariKod: null,
          KDV: 0.0,
          id: "0",
          kod: "",
          isim: null,
          tip: 0,
          intField: null,
        },
        Tumu: false,
        KomYuzde: null,
        KomTutar: 0,
        Para: "TL",
        Kur: 1.0,
        SaticiTip: 1,
        Satici: {
          YurtIci_YurtDisi: 0,
          CariKod: null,
          KDV: 0.0,
          id: "0",
          kod: "",
          isim: null,
          tip: 0,
          intField: null,
        },
        TarihBilgisi: {
          Tip: 0,
          BasTarihi: null,
          BitTarihi: null,
        },
      },
      komisyonParams: {
        Acente: {
          YurtIci_YurtDisi: 0,
          CariKod: null,
          KDV: 0.0,
          id: "0",
          kod: "",
          isim: null,
          tip: 0,
          intField: null,
        },
        Tumu: false,
        KomYuzde: null,
        KomTutar: 0,
        Para: "TL",
        Kur: 1.0,
        SaticiTip: 1,
        Satici: {
          YurtIci_YurtDisi: 0,
          CariKod: null,
          KDV: 0.0,
          id: "0",
          kod: "",
          isim: null,
          tip: 0,
          intField: null,
        },
        TarihBilgisi: {
          Tip: 0,
          BasTarihi: null,
          BitTarihi: null,
        },
      },
      totalCountText: null,
      siralamaItems: [
        {
          Text: this.$t('Agency-Code-Increasing'),
          Value: 0,
        },
        {
          Text: this.$t('Agency-Code-Decreasing'),
          Value: 1,
        },
      ],
      veriItem: [
        {
          Text: "25",
          Value: 25,
        },
        {
          Text: "50",
          Value: 50,
        },
        {
          Text: "100",
          Value: 100,
        },
      ],
      loadingmesaj: "",
      loadingvmodel: false,
      text1: "",
      snackbar: false,
      totalResultCount: 1,
      vmodelpagination: false,
      paginationDisabled: false,
      paximumOtel: null,
      komisyonListParams: {
        Filtreler: {
          AcenteKodu: null,
          SearchText: null,
        },
        Paging: {
          SiralamaTip: 0,
          SayfaNo: 1,
          VeriAdet: 25,
        },
      },
      acenteKomisyonList: [],
      islemTipi: null,
      kurList: [],
      doviztipi: [],
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      valid: true,
    };
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      this.kurCek();
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              let url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              let url = "#/";
              window.open(url, "_self");
            }
          } 
        });
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  methods: {
    paximumAdd() {
      this.$refs.serviceAcente.dialogOpen();
    },
    addDialogOpen() {
      this.clearDialog(1);
      this.komisyonDialog = true;
    },
    clearDialog(clearTip) {
      var element = null;
      if (clearTip == 1) {
        element = this.komisyonParams;
      } else if (clearTip == 2) {
        element = this.komisyonUpdateParams;
      }

      element.Acente.YurtIci_YurtDisi = 0;
      element.Acente.CariKod = null;
      element.Acente.KDV = 0.0;
      element.Acente.id = "0";
      element.Acente.kod = "";
      element.Acente.isim = null;
      element.Acente.tip = 0;
      element.Acente.intField = null;
      element.Tumu = false;
      element.KomYuzde = null;
      element.KomTutar = 0;
      element.Para = "TL";
      element.Kur = 1.0;
      element.SaticiTip = 1;
      element.Satici.YurtIci_YurtDisi = 0;
      element.Satici.CariKod = null;
      element.Satici.KDV = 0.0;
      element.Satici.id = "0";
      element.Satici.kod = "";
      element.Satici.isim = null;
      element.Satici.tip = 0;
      element.Satici.intField = null;
      element.TarihBilgisi.Tip = 0;
      element.TarihBilgisi.BasTarihi = null;
      element.TarihBilgisi.BitTarihi = null;
    },
    updateKomisyon() {
      this.loadingvmodel = true;
      let params = null;
      if (this.komisyonUpdateParams.TarihBilgisi.BasTarihi == null) {
        params = {
          Ref: this.komisyonUpdateParams.Ref,
          Acente: this.komisyonUpdateParams.Acente,
          Tumu: this.komisyonUpdateParams.Tumu,
          KomYuzde: this.komisyonUpdateParams.KomYuzde,
          KomTutar: this.komisyonUpdateParams.KomTutar,
          Para: this.komisyonUpdateParams.Para,
          Kur: this.komisyonUpdateParams.Kur,
          SaticiTip: this.komisyonUpdateParams.SaticiTip,
          Satici: {
            YurtIci_YurtDisi: this.komisyonUpdateParams.Satici.YurtIci_YurtDisi,
            CariKod: this.komisyonUpdateParams.Satici.null,
            KDV: this.komisyonUpdateParams.Satici.KDV,
            id: this.komisyonUpdateParams.Satici.id,
            kod: this.komisyonUpdateParams.Satici.kod,
            isim: this.komisyonUpdateParams.Satici.isim,
            tip: this.komisyonUpdateParams.Satici.tip,
            intField: this.komisyonUpdateParams.Satici.null,
          },
          TarihBilgisi: null,
        };
      } else {
        params = this.komisyonUpdateParams;
      }
      tool.http_post(this, "AcenteKomisyonTanimUpdate", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.getAcenteKomisyonListPageOne();
            this.komisyonUpdateDialog = false;
            this.loadingvmodel = false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.komisyonUpdateDialog = false;
            this.loadingvmodel = false;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
          this.komisyonUpdateDialog = false;
          this.loadingvmodel = false;
        }
      );
    },
    LoadKomisyon(id) {
      //this.clearDialog(2);
      let params = {
        Id: id,
      };
      tool.http_post(this, "AcenteKomisyonTanimLoad", params).then(
        (response) => {
          if (response.body.Status == true) {
            if (response.body.data.TarihBilgisi == null) {
              var TarihBilgisi = {
                Tip: 0,
                BasTarihi: null,
                BitTarihi: null,
              };
              response.body.data.TarihBilgisi = Object.assign({}, TarihBilgisi);
            }
            if (response.body.data.Satici == null) {
              var satici = {
                YurtIci_YurtDisi: 0,
                CariKod: null,
                KDV: 0.0,
                id: "0",
                kod: "",
                isim: null,
                tip: 0,
                intField: null,
              };
              response.body.data.Satici = Object.assign({}, satici);
            }
            this.komisyonUpdateParams = response.body.data;
            this.komisyonUpdateDialog = true;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
        }
      );
    },
    addKomisyon() {
      this.loadingvmodel = true;
      let params = null;
      if (this.komisyonParams.TarihBilgisi.BasTarihi == null) {
        params = {
          Acente: this.komisyonParams.Acente,
          Tumu: this.komisyonParams.Tumu,
          KomYuzde: this.komisyonParams.KomYuzde,
          KomTutar: this.komisyonParams.KomTutar,
          Para: this.komisyonParams.Para,
          Kur: this.komisyonParams.Kur,
          SaticiTip: this.komisyonParams.SaticiTip,
          Satici: {
            YurtIci_YurtDisi: this.komisyonParams.Satici.YurtIci_YurtDisi,
            CariKod: this.komisyonParams.Satici.null,
            KDV: this.komisyonParams.Satici.KDV,
            id: this.komisyonParams.Satici.id,
            kod: this.komisyonParams.Satici.kod,
            isim: this.komisyonParams.Satici.isim,
            tip: this.komisyonParams.Satici.tip,
            intField: this.komisyonParams.Satici.null,
          },
          TarihBilgisi: null,
        };
      } else {
        params = this.komisyonParams;
      }
      tool.http_post(this, "AcenteKomisyonTanimInsert", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.getAcenteKomisyonListPageOne();
            this.komisyonDialog = false;
            this.loadingvmodel = false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.komisyonDialog = false;
            this.loadingvmodel = false;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
          this.komisyonDialog = false;
          this.loadingvmodel = false;
        }
      );
    },
    getKur(tip) {
      if (this.kurList.length == 0) {
        if (this.kayitTarihi == null) {
          this.kayitTarihi = tool.Now_yyyy_MM_dd();
        }
        tool
          .http_post(this, "KurAra", {
            tarih: this.kayitTarihi,
          })
          .then(
            (response) => {
              this.kurList = response.body;
              this.selectKur(this.kurTipi, tip);
            },
            (response) => {
              this.val.Kur = 1;
            }
          );
      } else {
        this.selectKur(this.kurTipi, tip);
      }
    },
    selectKur(value, tip) {
      var resultSatis = this.kurList.find(this.paraAraSatis, tip);
      if (tip == 1) {
        if (resultSatis == undefined) {
          this.komisyonParams.Kur = 1;
        } else {
          this.komisyonParams.Kur = resultSatis.kur;
        }
      } else {
        if (resultSatis == undefined) {
          this.komisyonUpdateParams.Kur = 1;
        } else {
          this.komisyonUpdateParams.Kur = resultSatis.kur;
        }
      }
    },
    paraAraSatis(paraBirimi, tip) {
      if (tip == 1) {
        return paraBirimi.paraBirimi == this.komisyonParams.Para;
      } else {
        return paraBirimi.paraBirimi == this.komisyonUpdateParams.Para;
      }
    },
    kurCek() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params = {
        CompanyCode: credentials.SirketKodu,
      };

      this.$http
        .post(auth.API_URL + "api/currency/List", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.doviztipi = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            }
          }
        );
    },
    getparabirimi() {
      return helpers.getparabirimi();
    },
    deleteAcenteKomisyon(Ref) {
      this.loadingvmodel = true;
      let params = {
        Id: Ref,
      };
      tool.http_post(this, "AcenteKomisyonTanimDelete", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.getAcenteKomisyonListPageOne();
            this.loadingvmodel = false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
          this.loadingvmodel = false;
        }
      );
    },
    getAcenteKomisyonListPageOne() {
      this.komisyonListParams.Paging.SayfaNo = 1;
      this.getAcenteKomisyonList();
    },
    getAcenteKomisyonList() {
      this.acenteKomisyonList = [];
      this.totalResultCount = 1;
      this.loadingvmodel = true;
      let params = null;

      if (this.komisyonListParams.Filtreler.AcenteKodu != null) {
        params = {
          Filtreler: {
            AcenteKodu: this.komisyonListParams.Filtreler.AcenteKodu.kod,
            SearchText: this.komisyonListParams.Filtreler.SearchText,
          },
          Paging: {
            SiralamaTip: this.komisyonListParams.Paging.SiralamaTip,
            SayfaNo: this.komisyonListParams.Paging.SayfaNo,
            VeriAdet: this.komisyonListParams.Paging.VeriAdet,
          },
        };
      } else {
        params = this.komisyonListParams;
      }

      tool.http_post(this, "AcenteKomisyonTanimList", params).then(
        (response) => {
          if (response.body.Status == true) {
            if (response.body.PageTotals.TotalCount > 0) {
              this.totalCountText =
                "Toplam " +
                response.body.PageTotals.TotalCount +
                " Adet Kayıt Bulundu";
            } else {
              this.totalCountText = this.$t('No-Records-Found');
            }

            if (
              response.body.PageTotals.TotalCount >
              this.komisyonListParams.Paging.VeriAdet
            ) {
              this.totalResultCount = response.body.PageTotals.TotalPage;
              this.vmodelpagination = true;
              this.paginationDisabled = false;
            } else {
              this.totalResultCount = response.body.PageTotals.TotalPage;
              this.vmodelpagination = false;
              this.paginationDisabled = false;
            }

            this.acenteKomisyonList = response.body.data;
            this.loadingvmodel = false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
          this.loadingvmodel = false;
        }
      );
    },
  },
  watch: {
    "komisyonListParams.Paging.SayfaNo": function () {
      this.getAcenteKomisyonListPageOne();
    },
  },
  components: {
    loadingcomp,
    yetkidialog,
    snackbarcomp,
    genelarama,
    tarihim,
    serviceacentekomisyon,
  },
  filters: {
    priceFormat: function (price) {
      return Number.parseFloat(price).toFixed(2);
    },
    gettime: function (t) {
      return helpers.getTime(t);
    },
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    timeformat: function (c) {
      return helpers.timeformat(c);
    },
  },
};
</script>

<style>
</style>